var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.oaIsFollowed ? _c('div', [_c('PageTitle', [_vm._v("請加入好友")]), _c('p', {
    staticClass: "s-mb-10"
  }, [_vm._v(" 將 " + _vm._s(_vm.liffInfo.liff_og_title) + " 加為好友，才可開始團購、管理訂單及追蹤商品。"), _c('br'), _c('br'), _vm._v(" 點擊【加入好友】按鈕並綁定會員，一起加入團購吧！ ")]), _c('a', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "href": "https://line.me/R/ti/p/@".concat(_vm.oaId)
    }
  }, [_vm._v("加入好友")])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }